import React from "react";

const PRBadge = ({ reps }) => {
  return (
    <span className="pr-badge">
      <span className="pr-badge-star">&#9733;</span>
      {reps}RM PR
    </span>
  );
};

export default PRBadge;
